<template>
  <div class="container">
    <router-link :to="{name:'RoomEditView'}">
      {{ room.title }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'RoomListItem',
  props: ['room']
}
</script>

<style lang="scss" scoped>
  .container {
    border: 1px solid black;
    padding: 0.5em;
  }
</style>



// WEBPACK FOOTER //
// src/components/RoomListItem.vue